import { createSlice } from "@reduxjs/toolkit";
import { FETCH_ALL_POSTS } from "../constants/actionTypes";

const initialState = {
    isLoading: true,
    allPosts: [],
}

const postSlice = createSlice({
    name: FETCH_ALL_POSTS,
    initialState,
    reducers: {
        startLoading: (state) => {
            state.isLoading     = true;
        },
        endLoading: (state) => {
            state.isLoading     = false;
        },
        setPosts: (state, action) => {
            state.allPosts      = action.payload.data;
        }
    }
})

export const { startLoading, endLoading, setPosts } = postSlice.actions
export default postSlice.reducer